import { Box, FormControl, FormHelperText, Typography } from '@mui/material';
import { modules } from '@terraframing-suite/rx-config';
import { useContext } from './context.jsx';
import { StarterFertilizerInputs } from './starter-fertilizer/Inputs.jsx';
import { NitrogenInputs } from './nitrogen/Inputs.jsx';
import { FungicideInputs } from './early-season-fungicide/Inputs.jsx';
import { NitrogenProtectantInputs } from './nitrogen-protectant/Inputs.jsx';
import { LpkInputs } from '../lpk/actions/runLpk/LpkInputs.jsx';

const moduleInputs = {
  lpk: LpkInputs,
  nitrogen: NitrogenInputs,
  nitrogenProtectant: NitrogenProtectantInputs,
  starterFertilizer: StarterFertilizerInputs,
  earlySeasonFungicide: FungicideInputs,
};

export function ModuleInputs() {
  const { selectedModules, getError } = useContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {modules.map(buildModuleInputs)}
    </Box>
  );

  function buildModuleInputs(module) {
    const error = getError(module.id);
    const Inputs = moduleInputs[module.id];

    if (!selectedModules[module.id] || !Inputs) return null;

    return (
      <Box
        key={module.id}
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          p: { xs: 1, sm: 2, md: 3 },
          borderRadius: 2,
        }}
      >
        <Typography variant="body1" sx={{ mb: 2, fontWeight: 'bold' }}>
          {module.label}
        </Typography>
        {error && (
          <FormControl error sx={{ m: 0, mt: -2 }}>
            <FormHelperText sx={{ m: 0 }}>{error}</FormHelperText>
          </FormControl>
        )}
        <Inputs />
      </Box>
    );
  }
}
